import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import { renderToString } from 'react-dom/server';
import CIcon from '@coreui/icons-react';

//component - CoreUI / CTooltip
const CTooltip = (props) => {
     const {
          children,
          content = '',
          interactive = false,
          placement = 'top',
          trigger = 'mouseenter focus',
          advancedOptions = {},
          allowCopy = false,
          maxWidth = 350,
          customArrow = false,
     } = props;

     const computedContent = useCallback(() => {
          if (typeof content !== 'string') {
               return renderToString(content);
          }

          if (allowCopy) {
               const copyButtonHtml = `
                    <div
                         className="tooltip-fields"
                         style="display: flex; gap: 10px; padding: 10px max-width: 320px; word-break: break-all; max-height: 400px overflow-y: auto"
                    >
                         <div class="video-list" style="font-weight: 500; flex-grow: 1; flex-basis: 0; min-width: 0; word-break: break-word">${content.includes('\n') ? content.split('\n').map((line, i, arr) => `<div style="margin-bottom: ${i < arr.length - 1 ? '6px' : '0'}; line-height: 1.4">${line}</div>`).join('') : content}</div>
                         <div style="color: #20a8d8; background-color: #fff; border-radius: 12px; padding: 2px 10px; font-size: 12px; font-weight: 600; width: 62px; height: max-content; cursor: pointer">
                              <div
                                   class="icon-copy"
                                   onclick="navigator.clipboard.writeText('${content.replace(/'/g, "\\'").replace(/\n/g, "\\n")}')
                                        .then(() => { this.textContent = 'Copied!'; setTimeout(() => { this.textContent = 'Copy'; }, 2000); })
                                        .catch(err => console.error('Could not copy text: ', err));"
                              >
                                   Copy
                              </div>
                         </div>
                    </div>
               `;
               return copyButtonHtml;
          }

          return content;
     }, [content, allowCopy]);

     const config = {
          allowHTML: true,
          content: computedContent,
          interactive: interactive || allowCopy,
          placement,
          trigger,
          maxWidth,
          arrow: customArrow ? renderToString(<CIcon icon="arrowTooltip" className="arrow-tooltip-preview" />) : true,
          ...advancedOptions,
     };

     const key = useState(Math.random().toString(36).substr(2))[0];
     const instance = useRef();

     useEffect(() => {
          if (instance.current) {
               instance.current.setProps(config);
          }
     });

     useEffect(() => {
          const node = document.querySelector(`[data-tooltip="${key}"]`);
          instance.current = tippy(node, config);
          return () => instance.current.destroy();
     }, [key]); // eslint-disable-line react-hooks/exhaustive-deps

     return (
          <React.Fragment>
               {React.cloneElement(children, {
                    'data-tooltip': key,
               })}
          </React.Fragment>
     );
};

CTooltip.propTypes = {
     children: PropTypes.node,
     content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
     interactive: PropTypes.bool,
     allowCopy: PropTypes.bool,
     customArrow: PropTypes.bool,
     placement: PropTypes.oneOf([
          '',
          'top-end',
          'top',
          'top-start',
          'bottom-end',
          'bottom',
          'bottom-start',
          'right-start',
          'right',
          'right-end',
          'left-start',
          'left',
          'left-end',
     ]),
     trigger: PropTypes.string,
     advancedOptions: PropTypes.object,
     maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default CTooltip;
